import { IconProps } from './types';

const RefreshCcw = ({ color, dimension }: IconProps) => (
  <svg
    fill="none"
    height={dimension || 24}
    viewBox="0 0 24 24"
    width={dimension || 24}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3.99995V9.99995M1 9.99995H7M1 9.99995L5.64 5.63995C6.71475 4.56467 8.04437 3.77916 9.50481 3.35673C10.9652 2.93429 12.5089 2.8887 13.9917 3.22421C15.4745 3.55972 16.8482 4.26539 17.9845 5.27537C19.1209 6.28536 19.9828 7.56674 20.49 8.99995M23 20V14M23 14H17M23 14L18.36 18.36C17.2853 19.4352 15.9556 20.2207 14.4952 20.6432C13.0348 21.0656 11.4911 21.1112 10.0083 20.7757C8.52547 20.4402 7.1518 19.7345 6.01547 18.7245C4.87913 17.7145 4.01717 16.4332 3.51 15"
      stroke={color || '#101828'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export default RefreshCcw;
